import { render, staticRenderFns } from "./GaEventRowMenu.vue?vue&type=template&id=636a8b8e&scoped=true&"
import script from "./GaEventRowMenu.vue?vue&type=script&lang=ts&"
export * from "./GaEventRowMenu.vue?vue&type=script&lang=ts&"
import style0 from "./GaEventRowMenu.vue?vue&type=style&index=0&id=636a8b8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636a8b8e",
  null
  
)

export default component.exports